'use es6';

import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ChecklistRow extends Component {
  render() {
    const {
      result
    } = this.props;
    const {
      localizedTextKey
    } = result;
    return /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${localizedTextKey}.header`
        })
      }), /*#__PURE__*/_jsxs("td", {
        children: [result.displayValue, /*#__PURE__*/_jsx("span", {
          children: result.displayValueUnit
        })]
      }), /*#__PURE__*/_jsxs("td", {
        children: [result.displayRecommendationValue, /*#__PURE__*/_jsx("span", {
          children: result.displayRecommendationValueUnit
        })]
      }), /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${localizedTextKey}.result.recommendation`
        })
      })]
    });
  }
}